<template>
    <div style="padding-top: 30px">
        <v-row justify="center" class="mb-8">
            <v-card class="layout-content justify-center" style="align-self:center !important; width: 80%;">
                <v-row>
                    <v-col md="12">
                        <div class="pa-4" id="imprimir"  v-show="ver == true">
                            <div style="text-align:left" class="col-xs-6 col-xs col-md-4">
                                <img src="https://www.ausa.com.mx/img/logo-ver2.png" alt="LOGO" width="130" height="65" />
                            </div>

                            <div style="text-align:center !important">
                                <span style="color:Blue">GRUPO AUSA S.A. DE C.V.</span><br />
                                <span style="color:Blue">SOLICITUD DE PAGO</span>
                            </div>

                            <div style="float:left; width:33%; text-align:right">
                                <span id="fecha_Sol" runat="server"></span>
                            </div>
                            <div style="clear:both"></div>
                            <br /><br />
                            <div style="float:left; width:33%; text-align:right">
                                <span id="fecha_Sol" runat="server"></span>
                            </div>
                            <div style="clear:both"></div>
                            <br /><br />

                            <span class="texto">Ing. Luis A. Sanguino Gómez</span><br />
                            <span class="texto">P R E S E N T E</span>
                            <br /><br />
                            <div style="border:2px dashed gray" v-if="reporte.length > 0">
                                <table color="black">
                                    <tr>
                                        <td style="text-align:right">REPORTE: &nbsp; </td>
                                        <td><span id="DetReporte" runat="server">{{reporte[0].nrreporte}} - {{reporte[0].svindice}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:right">ASEGURADO: &nbsp;</td>
                                        <td><span id="DetAsegurado" runat="server">{{reporte[0].asnombre}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:right">PÓLIZA: &nbsp;</td>
                                        <td><span id="DetPoliza" runat="server">{{reporte[0].dapoliza}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:right">SINIESTRO:&nbsp; </td>
                                        <td><span id="DetSiniestro" runat="server">{{reporte[0].svnumsin}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:right">CONDUCTOR:&nbsp; </td>
                                        <td><span id="DetConductor" runat="server">{{reporte[0].svnomcond}}</span></td>
                                    </tr>
                                    <tr>
                                        <td style="text-align:right">ASEGURADORA: &nbsp;</td>
                                        <td><span id="DetAseguradora" runat="server">{{reporte[0].clnombre}}</span></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div >
                                <span id="span1" runat="server" class="texto">Por este conducto, solicito el pago de la cantidad de: $</span><span id="cantidadNum" runat="server" class="texto">{{datos[0].cantidad}}</span><br />
                                 <span id="NumLetra" runat="server" class="texto">( {{datos[0].cantidadtexto}} )</span>
                                <br /><br />
                                <span class="texto">Por concepto de: </span>
                                <div id="conceptoDe" runat="server" class="texto" color="grey lighten-4">
                                    <span color="black">
                                        {{datos[0].solicitudConcepto}}
                                    </span>
                                </div>
                                <br /><br />
                                      <span class="texto">Favor de hacer el depósito a nombre de: </span><span id="NombreDe" runat="server" class="texto">{{datos[0].depositar}}</span><br /><br />
                                <span class="texto">Al banco: </span><span id="banco" runat="server" class="texto">{{datos[0].banco}}</span><br /><br />
                                <span class="texto">Con número de cuenta: </span><span id="cuenta" runat="server" class="texto">{{datos[0].cuenta}}</span>
                                <br />
                                <span class="texto">Observaciones:</span><br />
                                <div id="observaciones" runat="server" class="texto" color="grey lighten-4">
                                    {{datos[0].observacion}}
                                </div>
                            </div>
                            <br /><br />
                            <span class="texto">Esperando contar con su aprobación y colaboración para su pronto pago.</span>
                            <br /><br /><br />
                            <div class="texto" style="text-align:center">
                                <span class="texto">ATENTAMENTE</span><br /><br /><br /><br />
                                ________________________________________<br />
                                <span class="texto">Firma Autorizada</span>
                            </div>
                        </div>
                    </v-col>
                    <v-row justify="center" class="mb-8">
                        <v-btn @click="imprimir()" class="ma-2"
                               color="primary">
                            Imprimir
                            
                        </v-btn>
                        
                        <v-btn color="error" @click="regresar()" class="ma-2">
                            Regresar
                        </v-btn>
                    </v-row>
                </v-row>
                
            </v-card>
        </v-row>
    </div>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import TramitePago from '@/services/TramitePago/TramitePago.Service.js';
    import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';
import router from '../../../../router/index';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                reporte: [],
                datos: [
                    {
                        cantidad: 0,
                        cantidadtexto: '',
                        depositar: '',
                        banco: '',
                        cuenta: '',
                        observacion: '',
                        solicitudConcepto: ''
                    }
                ],
                ver: false,
                reportes: [],
                asistenciaurl: '',
                //dato: [],
            }
        },
        //props: ['dato'],
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            imprimir() {

                var printContents = document.getElementById('imprimir').innerHTML;
                let w = window.open();
                w.document.write(printContents);
                w.document.close(); // necessary for IE >= 10
                w.focus(); // necessary for IE >= 10
                w.print();
                w.close();
                return true;
            },
            async regresar() {
                this.$router.push({ path: this.asistenciaurl + '/Garantias/SolicitarPago' });
                //switch (this.reportes.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `SolicitarPagoExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `SolicitarPagoRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `SolicitarPagoRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `SolicitarPagoRCMedico` });
                //        break;
                //}
            },
            imprimirElemento(elemento) {
                var ventana = window.open('', 'PRINT', 'height=400,width=600');
                ventana.document.write('<html><head><title>' + document.title + '</title>');
                ventana.document.write('<link rel="stylesheet" href="style.css">'); //Aquí agregué la hoja de estilos
                ventana.document.write('</head><body >');
                ventana.document.write(elemento.innerHTML);
                ventana.document.write('</body></html>');
                ventana.document.close();
                ventana.focus();
                ventana.onload = function () {
                    ventana.print();
                    ventana.close();
                };
                return true;
            },
            async DatosReporte() {
                let formdata = new FormData();
                
                formdata.append("reporte", this.reportes.nrreporte);
                formdata.append("indice", this.reportes.svindice);
                TramitePago.DatosReportePago(this, formdata).then(data => {
                    this.reporte = data;
                    this.ver = true;
                });
            }
        },
        async mounted() {
            this.reportes = await MetodosGenerales.obtenerSessionReporte('param');
            this.dato = this.$route.query.dato;
            this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reportes);
            
            this.changeReporteMenuOption("Garantías");
            if (this.dato == undefined) {
                this.$router.push({ path: this.asistenciaurl + '/Garantias/SolicitarPago' });
                //switch (this.reportes.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `SolicitarPagoExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `SolicitarPagoRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `SolicitarPagoRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `SolicitarPagoRCMedico` });
                //        break;
                //}
            }
            else {
                await this.DatosReporte();
                this.datos = this.dato;
            }
        },
    }
</script>